import { lazy } from 'react';

export const RequestsReportsPage = lazy(() => import('./RequestsReportsPage'));
